import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
declare var $: any;

@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.scss']
})
export class ContactoComponent implements OnInit {

  contacto = [
    {
      img:"/assets/img/contacto/contacto3.svg",
      nombreOficina:"Oficina central",
      telefono: "558626-0911 / 558626-0912",
      correo:["karina@plusbarrent.com.mx","contacto@plusbarrent.com.mx"],
      boton:"Más información"
    },
    {
      img:"/assets/img/contacto/contacto1.svg",
      nombreOficina:"Centro de atención Norte",
      telefono: "554979-1215",
      correo:["marialuisa@plusbarrent.com.mx","joseluis@plusbarrent.com.mx"],
      boton:"Más información"
    },
    {
      img:"/assets/img/contacto/contacto2.svg",
      nombreOficina:"Jurídico y Extrajudicial",
      telefono: "558626-0912",
      correo:[" juridico@plusbarrent.com.mx","extrajudicial@plusbarrent.com.mx"],
      boton:"Más información"
    },
    {
      img:"/assets/img/contacto/contacto4.svg",
      nombreOficina:"Renovaciones",
      telefono: "558626-0911 / 558626-0912",
      correo:["renovaciones@plusbarrent.com.mx"],
      boton:"Más información"
    }
  ]

  constructor() { }

  sliderCarusel(type:string,complement:string) {
    if (type == "left") {
      $("#"+complement).carousel('next');
    }else {
      $("#"+complement).carousel('prev');
    }
  }

  ngOnInit(): void {}

}
